module.exports = __webpack_public_path__ + "img/zw.7f6a3267.svg";